// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"f4a048a0","501":"6af19808","587":"b8d5027c","622":"db354831","651":"3e4191b3"}[chunkId] + ".chunk.js";
};